module.exports = __webpack_public_path__ + "static/charter-standard-f1385da081f53f5701d1fb75e6b9a7f7.png";